import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ConfigContext } from '../../providers/ConfigContext';
import { getDisplayImageUrl } from '../../utils/imageUtils';
import { SITE_NAME } from '../../config/siteContent';

const PLATFORM_ICONS = {
  instagram: 'fa-brands fa-instagram',
  facebook: 'fa-brands fa-facebook-f',
  tiktok: 'fa-brands fa-tiktok',
  twitter: 'fa-brands fa-x-twitter',
  youtube: 'fa-brands fa-youtube',
  whatsapp: 'fa-brands fa-whatsapp'
};

const LINK_STYLE = {
  color: 'var(--text-muted)',
  fontSize: '0.82rem',
  textDecoration: 'none',
  letterSpacing: '0.02em'
};

const FooterLinks = ({ title, links }) => (
  <div>
    <h4 style={{
      fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase',
      letterSpacing: '0.15em', marginBottom: '20px', fontFamily: 'var(--font-body)', color: 'var(--text-primary)'
    }}>{title}</h4>
    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {links.map((item) => (
        <li key={item.label} style={{ marginBottom: '10px' }}>
          <Link to={item.to} style={LINK_STYLE}>{item.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState([]);
  const { config } = React.useContext(ConfigContext);
  const brandName = SITE_NAME;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-content`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data.data?.socialLinks)) {
          setSocialLinks(data.data.socialLinks.filter((link) => link.enabled && link.url));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <footer style={{ background: '#ffffff', borderTop: '1px solid var(--border-light)', color: 'var(--text-primary)', marginTop: 'auto', fontFamily: 'var(--font-body)' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr', gap: '40px', padding: '60px 40px 40px' }}>
        <div>
          {config?.brand?.logo ? (
            <div style={{ marginBottom: '16px' }}>
              <img src={getDisplayImageUrl(config.brand.logo)} alt={brandName} style={{ maxHeight: '40px', maxWidth: '200px', objectFit: 'contain' }} />
            </div>
          ) : (
            <div style={{ fontFamily: 'var(--font-accent)', fontSize: '1.4rem', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '16px' }}>{brandName}</div>
          )}
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.7, marginBottom: '20px' }}>
            Indumentaria urbana y deportiva de fabricación propia en Uruguay. Mujer, hombre y niños. Venta minorista y mayorista con envíos a todo el país.
          </p>
          {socialLinks.length > 0 && (
            <div style={{ display: 'flex', gap: '12px' }}>
              {socialLinks.map((link) => (
                <a
                  key={link._id || `${link.platform}-${link.url}`}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.platform}
                  style={{ width: '36px', height: '36px', border: '1px solid var(--border-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-primary)', fontSize: '0.9rem', textDecoration: 'none' }}
                >
                  <i className={PLATFORM_ICONS[link.platform] || 'fas fa-globe'} aria-hidden="true" />
                </a>
              ))}
            </div>
          )}
        </div>

        <FooterLinks title="Tienda" links={[
          { label: 'Tienda', to: '/tienda' },
          { label: 'Mujer', to: '/mujer' },
          { label: 'Hombre', to: '/hombre' },
          { label: 'Niños', to: '/ninos' },
          { label: 'Ropa deportiva', to: '/ropa-deportiva' }
        ]} />
        <FooterLinks title="Información" links={[
          { label: 'Mayoristas', to: '/mayoristas' },
          { label: 'Nosotros', to: '/nosotros' },
          { label: 'Preguntas frecuentes', to: '/preguntas-frecuentes' }
        ]} />
        <FooterLinks title="Contacto" links={[
          { label: 'Contacto', to: '/contacto' },
          { label: 'Mi carrito', to: '/cart' },
          { label: 'Mi cuenta', to: '/profile' }
        ]} />
      </div>

      <div style={{ borderTop: '1px solid var(--border-light)', padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px', maxWidth: '1400px', margin: '0 auto' }}>
        <p style={{ color: 'var(--text-light)', fontSize: '0.75rem', margin: 0, letterSpacing: '0.05em' }}>&copy; {new Date().getFullYear()} {brandName}. Todos los derechos reservados.</p>
        <p style={{ color: 'var(--text-light)', fontSize: '0.75rem', margin: 0 }}>Desarrollado por <a href="https://dev.moreira.uy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Moreira dev</a></p>
      </div>

      <style>{`
        @media (max-width: 992px) { footer > div:first-child { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 576px) {
          footer > div:first-child { grid-template-columns: 1fr !important; text-align: center; padding: 30px 20px !important; }
          footer > div:first-child > div:first-child > div:last-child { justify-content: center; }
          footer > div:last-child { flex-direction: column; text-align: center; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
